import { ArgsType, Field, Int } from '@nestjs/graphql'

@ArgsType()
export class ReportPirateArgs {
  @Field()
  fileName!: string

  @Field(t => Int)
  bookId!: string // as it's being sent via the controller. Will be parsed.

  @Field()
  link!: string
}
